import styled, {css} from 'styled-components';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

const CalendarTitleContainer = styled.div`
	width: 100%;
	text-align: center;

	${({theme}) => css`
		margin-bottom: 0;
		margin: ${theme.spacing('3x')} 0;
	`}
`;

const CalendarTitle = styled.span`
	font-size: 18px;
	line-height: 24px;
	font-weight: 700;
	${({theme}) => css`
		color: ${theme.colors.light.text.primary};
	`}
`;

const CalendarDays = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
`;

export {Container, CalendarTitleContainer, CalendarTitle, CalendarDays};
